import Confetti from "react-confetti";
import React from "react";

const ConfettiEffect = () => {
    return (
        <Confetti
            width={2160}
            height={3840}
            numberOfPieces={250}
            colors={["#73B3FE", "#fFE7260", "#7D73FF", "#FFD791", "#FFC3DB", "#E1ACFF"]}
            tweenDuration={2000}
            gravity={0.1}
            recycle={false}
            friction={1}
            initialVelocityY={{ min: 10, max: 70 }}
            drawShape={(ctx) => {
                // if (Math.random() > 0.5) {
                //     ctx.beginPath();
                //     ctx.arc(0, 0, 25, 0, 2 * Math.PI);
                //     ctx.fill();
                //     ctx.closePath();
                // } else {
                //     ctx.beginPath();
                //     ctx.rect(-12.5, -12.5, 50, 50);
                //     ctx.fill();
                //     ctx.closePath();
                // }
                ctx.beginPath();
                ctx.rect(-12.5, -12.5, 50, 50);
                ctx.fill();
                ctx.closePath();
            }}
            className="pointer-events-none"
        />
    );
};

export default ConfettiEffect;
